import { Button, message, Modal, Select, Spin } from 'antd'
import React from 'react'
import { CustomRow, CustomCol } from '../../components/Custom';
import DetailTitle from '../../components/DetailTitle';
import FileUpload_JR from '../../components/FileUpload_JR';

import { Row,Col,Form, Input, InputNumber } from "antd";
import { houseTypeLabelMap, houseWindowTypeMap } from '../../axios/dictionaries';
import { post } from '../../axios';
import { API_houseType_create, API_houseType_edit, API_houseType_getById, API_salesroom_findList } from '../../axios/config';

class HouseTypeDetail extends React.Component{
  state = {
    id: null,
    visible: false,
    dataInfo: {},
    salesroomList: [],
    dataLoading: false,
    submitLoading: false
  }
  open(id = null) {
    if (id) {
      this.postHouseTypeGet(id)
    }
    this.postSalesroomList()
    this.setState({ visible: true, id })
    return new Promise((resolve,reject) => {
      this.monitor = { resolve, reject }
    })
  }
  close() {
    this.setState({ visible: false })
    this.props.form.resetFields()
    this.fileUploadRef_attachIds.set([])
  }
  renderFooter() {
    return (
      <div className="app-modal-footer">
        <Button type="primary" onClick={this.handleSubmit.bind(this)} loading={this.state.submitLoading}>保存</Button>
        <Button onClick={this.close.bind(this)}>取消</Button>
      </div>
    )
  }
  postSalesroomList() {
    post({ url: API_salesroom_findList }).then(res =>{
      this.setState({ salesroomList: res })
    })
  }
  postHouseTypeSubmit(data) {
    const url = data.id ? API_houseType_edit : API_houseType_create
    this.setState({ submitLoading: true })

    return post({ url, data }).then(res => {
       // this.setState({ submitLoading: false })
    }).finally(err => {
      this.setState({ submitLoading: false })
    })
  }
  postHouseTypeGet(id) {
    this.setState({ dataLoading: true })
    post({ url: API_houseType_getById + '?roomTypeId=' + id  }).then(res => {
      const data = {
        balcony: res.balcony,
        ccbProjectId: res.ccbProjectId,
        bathroom: res.bathroom,
        bedroom: res.bedroom,
        ccbProjectName: res.ccbProjectName,
        kitchen: res.kitchen,
        label: res.label ? res.label.split(','): [],
        livingroom: res.livingroom,
        maxArea: res.maxArea,
        maxRent: res.maxRent,
        minArea: res.minArea,
        minRent: res.minRent,
        roomTypeName: res.roomTypeName,
        windowType:res.windowType
      }

      this.props.form.setFieldsValue(data)
      this.fileUploadRef_attachIds.set(res.roomTypeImages)
      this.setState({ dataLoading: false })
    }).catch(err => {
      this.setState({ dataLoading: false });
    })
  }
  handleSubmit() {
    this.props.form.validateFields((err, values) => {
      if (err) return
      values.id = this.state.id || undefined
      values.label = values.label.join(',')
      values.attachIds = this.fileUploadRef_attachIds.get().map(e => e.id)
      if (values.attachIds.length < 5 || values.attachIds.length > 10) return message.warning('介绍图片最少需5张，最多只能十张！')
      if (values.minArea > values.maxArea) return message.warning('最小计租面积 不能大于 最大计租面积')
      if (values.minRent > values.maxRent) return message.warning('最小租金 不能大于 最大租金')
      this.postHouseTypeSubmit(values).then(() => {
        this.close()
        this.monitor.resolve()
        message.success('保存成功')
      }).catch((e) => {
        message.error(e.message)
      })
    })
  }
  render(){
    const modalConfig = {
      title: this.state.id ? '编辑户型' : '新增户型',
      visible: this.state.visible,
      footer: this.renderFooter(),
      width: 642,
      onCancel: () => this.close()
    }
    const { getFieldDecorator, getFieldValue } = this.props.form
    const labelWidth = 100
    const labelValue = getFieldValue('label')
    return (
      <Modal {...modalConfig}>
        <Spin spinning={this.state.dataLoading}>
          <div className="custom" style={{padding: 20}}>
            <Form  labelCol={{ span: 0 }} wrapperCol={{ span: 24 }}>
              <Row>
                <Col span={24}>
                  <DetailTitle title="基本信息" boxStyle={{ marginTop: '0' }} />
                  <CustomRow >

                    <CustomCol labelStyle={{ width: labelWidth }} label="户型名称">
                        {getFieldDecorator('roomTypeName', {
                            rules: [{ required: true, message: '请输入户型名称', }],
                        })(
                            <Input
                                placeholder={'请输入'}
                                autoComplete={'off'}
                            />
                        )}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} label="所属门店">
                        {getFieldDecorator('ccbProjectId', {
                            rules: [{
                                required: true, message: '请选择所属门店',
                            }],
                        })(
                          <Select placeholder="请选择">
                            {this.state.salesroomList.map(e => (
                              <Select.Option key={e.id} value={e.id}>{ e.projectName }</Select.Option>
                            ))}
                          </Select>
                        )}
                    </CustomCol>
                  </CustomRow>
                  <CustomRow divider>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{width: 500}} label="推荐标签">
                      {getFieldDecorator('label', {
                          rules: [{
                              required: true, message: '请选择推荐标签',
                          }],
                      })(
                        <Select
                            mode="multiple"
                            tokenSeparators={[',']}
                            placeholder="请选择(最多选择3个)"
                        >
                          {
                            labelValue && labelValue.length >= 3 ?
                            [] :
                            houseTypeLabelMap.map((item, index) => <Select.Option key={ item.value } value={ item.value }>{ item.title }</Select.Option>)
                          }
                        </Select>
                      )}
                    </CustomCol>

                  </CustomRow>

                  <DetailTitle title="面积租金" />

                  <CustomRow >
                  <CustomCol labelStyle={{ width: labelWidth }} label="最小计租面积">
                      {getFieldDecorator('minArea', {
                          rules: [{
                              required: true, message: '请输入最小计租面积',
                          }],
                      })(
                        <InputNumber
                          min={5}
                          max={1000}
                          placeholder={`范围: 5 ~ 1000`}
                          autoComplete={'off'}
                        />
                      )}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} label="最大计租面积">
                      {getFieldDecorator('maxArea', {
                          rules: [{
                              required: true, message: '请输入最大计租面积',
                          }],
                      })(
                          <InputNumber
                              min={5}
                              max={1000}
                              placeholder={`范围: 5 ~ 1000`}
                              autoComplete={'off'}
                          />
                      )}
                    </CustomCol>
                  </CustomRow>
                  <CustomRow divider>
                  <CustomCol labelStyle={{ width: labelWidth }} label="最小租金">
                      {getFieldDecorator('minRent', {
                          rules: [{
                              required: true, message: '请输入最小租金',
                          }],
                      })(
                          <InputNumber
                              min={10}
                              max={100000}
                              placeholder={`范围: 10 ~ 100000`}
                              autoComplete={'off'}
                          />
                      )}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} label="最大租金">
                      {getFieldDecorator('maxRent', {
                          rules: [{
                              required: true, message: '请输入最大租金',
                          }],
                      })(
                          <InputNumber
                              min={10}
                              max={100000}
                              placeholder={`范围: 10 ~ 100000`}
                              autoComplete={'off'}
                          />
                      )}
                    </CustomCol>
                  </CustomRow>
                  <DetailTitle title="户型结构"  />
                  <CustomRow >
                    <CustomCol labelStyle={{ width: labelWidth }} label="阳台">
                      {getFieldDecorator('balcony', {
                          rules: [{
                              required: true, message: '请输入阳台个数',
                          }],
                      })(
                          <Select placeholder="请选择">
                            { Array(10).fill().map((e,i) => <Select.Option key={i} value={i} >{i}个</Select.Option>) }
                          </Select>
                      )}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} label="卫生间">
                      {getFieldDecorator('bathroom', {
                          rules: [{
                              required: true, message: '请选择卫生间个数',
                          }],
                      })(
                        <Select placeholder="请选择">
                          { Array(10).fill().map((e,i) => <Select.Option key={i} value={i}>{i}个</Select.Option>) }
                        </Select>
                      )}
                    </CustomCol>
                  </CustomRow>
                  <CustomRow divider>
                    <CustomCol labelStyle={{ width: labelWidth }} label="卧室">
                      {getFieldDecorator('bedroom', {
                          rules: [{
                              required: true, message: '请选择卧室个数',
                          }],
                      })(
                        <Select placeholder="请选择">
                          { Array(9).fill().map((e,i) => <Select.Option key={i+1}>{i+1}个</Select.Option>) }
                        </Select>
                      )}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} label="厨房">
                      {getFieldDecorator('kitchen', {
                          rules: [{
                              required: true, message: '请选择厨房个数',
                          }],
                      })(
                        <Select placeholder="请选择">
                          { Array(10).fill().map((e,i) => <Select.Option key={i} value={i}>{i}个</Select.Option>) }
                        </Select>
                      )}
                    </CustomCol>
                  </CustomRow>
                  <CustomRow divider>
                    <CustomCol labelStyle={{ width: labelWidth }} label="客厅餐厅">
                      {getFieldDecorator('livingroom', {
                          rules: [{
                              required: true, message: '请选择客厅餐厅个数',
                          }],
                      })(
                        <Select placeholder="请选择">
                          { Array(10).fill().map((e,i) => <Select.Option key={i} value={i}>{i}个</Select.Option>) }
                        </Select>
                      )}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} label="窗户">
                      {getFieldDecorator('windowType', {
                          rules: [{
                              required: true, message: '请选择窗户',
                          }],
                      })(
                        <Select
                            showSearch
                            placeholder="请选择"
                        >
                            {houseWindowTypeMap.map((item, index) => <Select.Option key={ item.value } value={ item.value }>{ item.title }</Select.Option>)}
                        </Select>

                      )}
                    </CustomCol>

                  </CustomRow>
                  <DetailTitle title="介绍图片" />
                  <div style={{marginBottom: 10}}>最少5张, 最多10张</div>
                  <FileUpload_JR hasTitle ref={(ref) => this.fileUploadRef_attachIds = ref}  count={10}  attachType={16} />
                </Col>
              </Row>
            </Form>
          </div>
        </Spin>
      </Modal>
    )
  }
}

export default Form.create({ wrappedComponentRef: true })(HouseTypeDetail)


// WEBPACK FOOTER //
// ./src/page/HouseType/detail.jsx